import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import '../style/carusel.scss';

export const MarqueeAnnouncement = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      className="marquee-announcement"
      sx={{
        width: '100%',
        background: 'linear-gradient(135deg, #0B5C87 0%, #0E749C 100%)',
        overflow: 'hidden',
        position: 'relative',
        padding: isMobileScreen ? '14px 0' : '16px 0',
        zIndex: 10,
        boxShadow: '0 2px 8px rgba(1, 72, 107, 0.15)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Box
        className="marquee-content"
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          fontFamily: 'Mark-Medium',
          fontSize: isMobileScreen ? '14px' : '16px',
          color: '#FFFFFF',
          animation: 'marquee-scroll 30s linear infinite',
          letterSpacing: '0.3px',
        }}
      >
        <span style={{ marginRight: '60px' }}>{t('marqueeAnnouncement')}</span>
        <span style={{ marginRight: '60px' }}>{t('marqueeAnnouncement')}</span>
        <span style={{ marginRight: '60px' }}>{t('marqueeAnnouncement')}</span>
      </Box>
    </Box>
  );
};
